import * as React from 'react';

import { shortenNumber } from '@cian/utils/lib/shared/shorten_number';

import { Room } from '../../../store/filters/model';
import { IRoom } from '../../../store/pik_data/gks';
import { UndergroundIcon } from '../../../ui/icon/icons/underground';
import { PromoLabel } from '../../../ui/promo_label/promo_label';
import { IFinishInfo, IUndegroundInfo } from '../../../../typings/api';
import { ERoom } from '../../../repositories/monolith-python/v1/filter-pik-newbuildings';

const styles = require('./gk.css');

const mapRoomToText: { [key: string]: string } = {
  fourRoom: '4-комн.',
  oneRoom: '1-комн.',
  studio: 'студия',
  threeRoom: '3-комн.',
  twoRoom: '2-комн.',
  fiveRoom: '5-комн.',
};

interface IProps {
  address?: string;
  imgUrl?: string;
  promoLabel?: string;
  publicUrl?: string;
  rooms: IRoom[];
  title?: string;
  finishInfo?: IFinishInfo;
  undegroundInfo?: IUndegroundInfo;
}

export class GK extends React.PureComponent<IProps, object> {
  public render() {
    const { props } = this;

    if (props.rooms.length === 0) {
      return null;
    }

    const roomsWithFirstStudio = [props.rooms[props.rooms.length - 1], ...props.rooms.slice(0, -1)];

    return (
      <article className={styles['gk']}>
        <a href={props.publicUrl} target="_blank" rel="noreferrer" className={styles['link']}>
          <figure className={styles['photo']} style={{ backgroundImage: `url(${props.imgUrl})` }}>
            {this.renderPromoLabel()}
            {this.renderFinishInfo()}
          </figure>
          <div className={styles['info']}>
            {this.renderTitle()}
            {this.renderUnderground()}
            {this.renderAddress()}
            {this.renderRooms(roomsWithFirstStudio)}
          </div>
        </a>
      </article>
    );
  }

  private renderPromoLabel = () => {
    const { promoLabel } = this.props;

    if (!promoLabel) {
      return null;
    }

    return <PromoLabel labelStyle={styles['promo-label']}>{promoLabel}</PromoLabel>;
  };

  private renderFinishInfo = () => {
    const { finishInfo } = this.props;

    if (!finishInfo) {
      return null;
    }

    return <div className={styles['finish-label']}>{finishInfo.label}</div>;
  };

  private renderTitle = () => {
    const { title } = this.props;

    if (!title) {
      return null;
    }

    return <h4 className={styles['title']}>{title}</h4>;
  };

  private renderUnderground = () => {
    const { undegroundInfo } = this.props;

    if (!undegroundInfo) {
      return null;
    }

    return (
      <div className={styles['underground']}>
        <UndergroundIcon color={`#${undegroundInfo.lineColor}`} />
        <span className={styles['underground-title']}>{undegroundInfo.title}</span>
      </div>
    );
  };

  private renderAddress = () => {
    const { address } = this.props;

    if (!address) {
      return null;
    }

    return <p className={styles['address']}>{address}</p>;
  };

  private getRoomText = (roomType: Room) => mapRoomToText[roomType as string];

  private renderRooms = (rooms: IRoom[]) => (
    <ul className={styles['rooms']}>
      {rooms.map(room => {
        const minPrice = shortenNumber(room.minPrice).replace('.', ',');
        const noData = Number(room.minPrice) === 0;
        const minPriceLabel = noData ? 'нет данных' : `от ${minPrice} руб.`;

        if (room.type === ERoom.FiveRoom && noData) {
          return null; // Пятикомнатных квартир очень мало. Показываем строчку только если они есть в продаже
        }

        return (
          <li key={room.type} className={styles['room']}>
            <div className={styles['count']}>{this.getRoomText(room.type)}</div>
            <div className={styles['line']} />
            <div className={styles['price']}>{minPriceLabel}</div>
          </li>
        );
      })}
    </ul>
  );
}
